import { render, staticRenderFns } from "./ServiceChoice.vue?vue&type=template&id=ee66df6a"
import script from "./ServiceChoice.vue?vue&type=script&lang=js"
export * from "./ServiceChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports